import React, { FunctionComponent } from "react";
import { Form, Field } from "react-final-form";
import i18next from "i18next";

import {
  composeValidators,
  emailValidation,
  requiredValidation,
} from "helper/validations";

import Button from "components/Button/Button";
import Input from "components/Input/Input";
import { ICreateUserFormProps } from "./types";
import { CustomForm, ButtonContainer } from "./styles";
import "./i18n";

const CreateUserForm: FunctionComponent<ICreateUserFormProps> = ({
  onSubmit,
}) => (
  <Form
    onSubmit={onSubmit}
    render={({ handleSubmit, submitting, pristine }) => (
      <CustomForm data-testid="create-user-form" onSubmit={handleSubmit}>
        <Field
          label={i18next.t("CREATE_USER_FORM:EMAIL")}
          name="email"
          render={Input}
          type="email"
          validate={composeValidators(requiredValidation, emailValidation)}
        />
        <ButtonContainer>
          <Button disabled={pristine || submitting} type="submit">
            {i18next.t("CREATE_USER_FORM:SUBMIT_BUTTON")}
          </Button>
        </ButtonContainer>
      </CustomForm>
    )}
  />
);

export default CreateUserForm;
